import React from "react";
import { Link } from "react-router-dom";

export default function NoAccess() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow-sm border-0" style={{ maxWidth: "450px", width: "100%" }}>
        <div className="card-body text-center p-4">
          <div className="mb-3">
            <span style={{ fontSize: "40px" }}>🔒</span>
          </div>

          <h4 className="mb-3">
            Сизда ушбу саҳифага кириш рухсати йўқ
          </h4>

          <p className="text-muted">
            Ҳуқуқларингизни текширинг ёки администраторга мурожаат қилинг.
          </p>

          <div className="d-grid gap-2 mt-4">
            <Link to="/" className="btn btn-dark">
              Асосий менюга қайтиш
            </Link>

            <Link to={-1} className="btn btn-outline-secondary">
              Орқага
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
